import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import HealthSafetyList from "./HomeVisit/HealthSafety/HealthSafetyList";

import {
  fetchHealthSafetyForms,
  deleteHealthSafetyForm,
} from "../store/slices/healthSafetyFormSlice";

const HealthSafety = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { healthSafetyForms, isLoading } = useSelector(
    (state) => state.healthSafetyForm
  );

  useEffect(() => {
    dispatch(fetchHealthSafetyForms());
  }, [dispatch]);

  const handleAdd = () => navigate("/home-visit/health-safety/add");

  const handleEdit = (id) => {
    const form = healthSafetyForms.find((f) => f.id === id);
    navigate(`/home-visit/health-safety/edit/${id}`, { state: { assessment: form } });
  };

  const handleDelete = async (id) => {
    await dispatch(deleteHealthSafetyForm(id));
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        <div className="card">
          <div className="card-body p-0">
            <HealthSafetyList
              records={healthSafetyForms}
              loading={isLoading}
              onAdd={handleAdd}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HealthSafety;
